import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const emptyFormControlPresets = {
    ErrorMessageWithIcon: ({ children }) => _jsx(_Fragment, { children: children }),
};
//# sourceMappingURL=formControl.js.map